(ns frontend.ux-overhaul.page-components.navigation.events
  (:require
   [re-frame.core :as rf]
   [frontend.routing :as routing]
   [frontend.ux-overhaul.page-components.navigation.subs :as navigation-subs]))

(rf/reg-event-db
 ::set-active-nav
 (fn [db [_ active-nav]]
   (assoc db :active-nav active-nav)))

(rf/reg-event-db
 ::toggle-modal
 (fn [db _]
   (assoc db :modal-open? (not (:modal-open? db)))))

(rf/reg-event-db
 ::close-modal
 (fn [db _]
   (assoc db :modal-open? false)))

;; Navigation event that calls a modal closing function
(rf/reg-event-fx
 ::navigate-to
 (fn [{:keys [db]} [_ {:keys [path]}]]
   (let [path (if-not (seqable? path) [path] path)]
     {:db (-> db
              (assoc :modal-open? false)
              (assoc :active-nav (first path)))
      ::routing/old-routing {:path-args path}})))

(rf/reg-event-db
 ::show-all-pipelines
 (fn [db _]
   (assoc db :show-all-pipelines? (not (:show-all-pipelines? db)))))

(rf/reg-event-db
 ::show-all-favorites
 (fn [db _]
   (assoc db :show-all-favorites? (not (:show-all-favorites? db)))))

(rf/reg-event-db
 ::toggle-webentries
 (fn [db _]
   (assoc db :show-all-webentries? (not (:show-all-webentries? db)))))
